import { createAction, props } from '@ngrx/store';

import { GetVehicleResponse } from '../../../features/vehicles/domain/vehicle.model';
import * as ActionTypes from './vehicle.actionTypes';

export const loadVehicle = createAction(ActionTypes.LOAD_VEHICLE, props<{ vehicle: GetVehicleResponse }>());
